import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { mapActions } from "vuex";

export const exportReportHistoryMixin = {
  mixins: [managementDatatableMixin],

  data() {
    return {
      reports: [],

      interval: null,
      loading: true
    };
  },

  methods: {
    ...mapActions([
      "GET_EXPORTS_BY_TYPE",
      "removeExportByUUID",
      "cancelExportByUUID"
    ]),

    async getExports(workspaceOptions) {
      try {
        this.loading = true;
        this.reports = await this.GET_EXPORTS_BY_TYPE(this.historyFilter);
      } catch (error) {
        console.error(error);
      } finally {
        this.filterWorkspaces(workspaceOptions);
        this.loading = false;
      }
    },

    stopHistoryRequests() {
      clearInterval(this.interval);
      this.interval = null;
    },

    isSuccessful(item) {
      return item.status === "success" && item.step === "creating_zip";
    },

    isDeletable(item) {
      return (
        item.status === "fail" ||
        this.isSuccessful(item) ||
        item.status === "canceled"
      );
    },

    getWorkspaceName(workspaceID) {
      let name = workspaceID;
      let workspace = this.workspaceOptions.find(
        item => item.wp_id === workspaceID
      );
      if (workspace && workspace.wp_label && workspace.wp_label !== "") {
        name = workspace.wp_label;
      }
      return name;
    },

    getStepAndStatus(exportItem) {
      let step = this.getStep(exportItem);
      let status = this.getStatus(exportItem);
      return step + ": " + status;
    },

    getStep(exportItem) {
      let step;
      if (
        exportItem.step === "creating_zip" ||
        exportItem.status === "fail" ||
        exportItem.status === "canceled"
      ) {
        step = this.$i18n.t("Finished");
      } else {
        step = this.$i18n.t("import_export." + exportItem.step);
        if (step.includes("import_export")) {
          step = exportItem.step;
        }
      }
      return step;
    },

    getStatus(exportItem) {
      let status = exportItem.status;
      if (exportItem.status === "fail") {
        status = this.$i18n.t("Fail");
      } else if (this.isSuccessful(exportItem)) {
        status = this.$i18n.t("Success");
      } else if (exportItem.status === "canceled") {
        status = this.$i18n.t("Canceled");
      } else if (exportItem.status !== "fail") {
        status = this.$i18n.t("Processing");
      }
      return status;
    },

    downloadExport(url, ele) {
      if (ele.isTrusted === true) {
        // let fileName = url.substring(url.lastIndexOf("/") + 1);
        // FileSaver.saveAs(url, fileName);
        window.open(url);
      }
    },

    cancelExport(item) {
      this.cancelExportByUUID(item.uuid)
        .then(() => this.getExports())
        .catch(error => {
          console.log(error);
        });
    },

    askConfirmationToDeleteItem(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },

    filterWorkspaces(workspaceOptions) {
      if (workspaceOptions) {
        for (let i = 0; i < this.reports.length; i++) {
          const element = this.reports[i];
          if (!workspaceOptions.some(e => e.wp_id === element.workspace_id)) {
            this.reports.splice(i, 1);
            i--;
          }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/exportReportHistoryMixin.js